import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("客户端性能")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("报告列表")
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "手动生成报告", -1)
const _hoisted_4 = { class: "reportList" }
const _hoisted_5 = { class: "operationBtn" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_8 = { class: "operationBtn" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, "发送邮件", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("span", null, " 删除 ", -1)
const _hoisted_16 = { class: "dialogTitle" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", null, "手动生成报告", -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("生成报告")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Processing Center")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Workspace")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("item one")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("item two")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("item three")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("item four")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("item one")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("item two")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("item three")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Info")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Orders")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_menu_item = _resolveComponent("el-menu-item")
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")
  const _component_el_menu = _resolveComponent("el-menu")
  const _component_el_footer = _resolveComponent("el-footer")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_main, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_breadcrumb, {
                "separator-class": "el-icon-arrow-right",
                class: "PosTitle"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_breadcrumb_item, null, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_breadcrumb_item, null, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    class: "btnStyle",
                    size: "small",
                    type: "primary",
                    onClick: _ctx.generateReportsManually,
                    disabled: _ctx.get_is_super
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tooltip, {
                        effect: "dark",
                        content: "暂无管理员权限",
                        placement: "top",
                        disabled: !_ctx.get_is_super
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_divider),
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_el_card, { class: "spacName tableMinH" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form, {
                      inline: true,
                      size: "mini",
                      class: "spacForm"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "风险等级" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.status_search,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.status_search = $event)),
                              placeholder: "请选择",
                              clearable: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.status_options, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "报告名称" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.name_search,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.name_search = $event)),
                              placeholder: "任务名称"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "报告创建人" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.report_creator,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.report_creator = $event)),
                              placeholder: "审批人"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "老版本号" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.report_old_version,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.report_old_version = $event)),
                              multiple: "",
                              "collapse-tags": "",
                              placeholder: "老版本号"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filterVersion('old'), (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128)),
                                _createVNode("div", _hoisted_5, [
                                  _createVNode(_component_el_button, {
                                    sizi: "mini",
                                    class: "operationBtn",
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleClearAll('old')))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_6
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_button, {
                                    sizi: "mini",
                                    type: "primary",
                                    class: "operationBtn",
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleSelectAll('old')))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_7
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "新版本号" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.report_new_version,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.report_new_version = $event)),
                              multiple: "",
                              "collapse-tags": "",
                              placeholder: "新版本号"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filterVersion('new'), (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128)),
                                _createVNode("div", _hoisted_8, [
                                  _createVNode(_component_el_button, {
                                    sizi: "mini",
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleClearAll('new')))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_9
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_button, {
                                    sizi: "mini",
                                    type: "primary",
                                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleSelectAll('new')))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_10
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onSearch('Search')))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_11
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              type: "info",
                              onClick: _ctx.onClear
                            }, {
                              default: _withCtx(() => [
                                _hoisted_12
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_el_table, {
                      data: _ctx.report_list.results,
                      size: "mini",
                      "header-cell-class-name": "tabelHeader"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          label: "风险等级",
                          "column-key": "risk",
                          filters: [
                  { text: '高风险', value: '高风险' },
                  { text: '低风险', value: '低风险' },
                ],
                          "filter-method": _ctx.filterHandler,
                          "min-width": "4%"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode("span", {
                              style: 
                      scope.row.risk === '高风险'
                        ? 'color: red'
                        : 'color: #00b050'
                    
                            }, _toDisplayString(scope.row.risk), 5)
                          ]),
                          _: 1
                        }, 8, ["filter-method"]),
                        _createVNode(_component_el_table_column, {
                          label: "报告名称",
                          "min-width": "14%"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_input, {
                              class: "report_name",
                              modelValue: scope.row.report_name,
                              "onUpdate:modelValue": ($event: any) => (scope.row.report_name = $event),
                              placeholder: "请输入内容",
                              onChange: ($event: any) => (_ctx.getReportName(scope.row))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "create_date",
                          label: "报告时间",
                          "min-width": "6%"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "creator",
                          label: "报告创建人",
                          "min-width": "3%"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "old_version",
                          label: "老版本号",
                          "column-key": "old_version",
                          filters: _ctx.filterVersion('old'),
                          "filter-method": _ctx.filterHandler,
                          "min-width": "5%"
                        }, null, 8, ["filters", "filter-method"]),
                        _createVNode(_component_el_table_column, {
                          prop: "new_version",
                          label: "新版本号",
                          "column-key": "new_version",
                          filters: _ctx.filterVersion('new'),
                          "filter-method": _ctx.filterHandler,
                          "min-width": "5%"
                        }, null, 8, ["filters", "filter-method"]),
                        _createVNode(_component_el_table_column, {
                          label: "操作",
                          width: "260"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_button, {
                              size: "mini",
                              onClick: ($event: any) => (_ctx.handleEdit(scope.$index, scope.row)),
                              type: "primary"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_13
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_el_popconfirm, {
                              title: "确认发送邮件吗？",
                              onConfirm: ($event: any) => (_ctx.saveEmail(scope.row)),
                              placement: "top"
                            }, {
                              reference: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  size: "mini",
                                  disabled: _ctx.get_is_super,
                                  type: "success"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_14
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 2
                            }, 1032, ["onConfirm"]),
                            _createVNode(_component_el_popconfirm, {
                              onConfirm: ($event: any) => (_ctx.handleDelete(scope.$index, scope.row)),
                              title: "确认删除该报告？"
                            }, {
                              reference: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  size: "mini",
                                  type: "danger",
                                  disabled: _ctx.get_is_super
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_15
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 2
                            }, 1032, ["onConfirm"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"]), [
                      [_directive_loading, _ctx.loading]
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_dialog, {
            modelValue: _ctx.dialogFormVisible,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.dialogFormVisible = $event)),
            width: "790px"
          }, {
            title: _withCtx(() => [
              _createVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode(_component_el_divider)
              ])
            ]),
            footer: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.generateReport,
                size: "small"
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                inline: true,
                model: _ctx.generateReportVersion,
                "label-position": "top",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "旧版本" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.generateReportVersion.oldEdition,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.generateReportVersion.oldEdition = $event)),
                        id: "old_version",
                        placeholder: "请选择"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_version_options, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: index,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "新版本" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.generateReportVersion.newEdition,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.generateReportVersion.newEdition = $event)),
                        id: "new_version",
                        placeholder: "请选择",
                        onChange: _ctx.selectVersion
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_version_options, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: index,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "场景" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.generateReportVersion.scenetion,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.generateReportVersion.scenetion = $event)),
                        multiple: "",
                        placeholder: "请选择"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_scene_version, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.scene_id_id,
                              label: item.scene_id__chinese,
                              value: item.scene_id_id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_footer, { class: "footerStyle" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                inline: true,
                size: "mini"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "每页" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.record,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.record = $event)),
                        style: {"width":"50px"},
                        onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onSearch('paging')))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "条记录" }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_pagination, {
                        onCurrentChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onSearch('paging'))),
                        currentPage: _ctx.currentPage1,
                        "onUpdate:currentPage": _cache[18] || (_cache[18] = ($event: any) => (_ctx.currentPage1 = $event)),
                        "page-size": _ctx.record,
                        layout: "total, prev, pager, next, jumper",
                        total: _ctx.report_list.count
                      }, null, 8, ["currentPage", "page-size", "total"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu, {
                "default-active": _ctx.activeIndex,
                class: "el-menu-demo",
                mode: "horizontal",
                onSelect: _ctx.handleSelect
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, { index: "1" }, {
                    default: _withCtx(() => [
                      _hoisted_19
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_sub_menu, { index: "2" }, {
                    title: _withCtx(() => [
                      _hoisted_20
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, { index: "2-1" }, {
                        default: _withCtx(() => [
                          _hoisted_21
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, { index: "2-2" }, {
                        default: _withCtx(() => [
                          _hoisted_22
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, { index: "2-3" }, {
                        default: _withCtx(() => [
                          _hoisted_23
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_sub_menu, { index: "2-4" }, {
                        title: _withCtx(() => [
                          _hoisted_24
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_menu_item, { index: "2-4-1" }, {
                            default: _withCtx(() => [
                              _hoisted_25
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_menu_item, { index: "2-4-2" }, {
                            default: _withCtx(() => [
                              _hoisted_26
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_menu_item, { index: "2-4-3" }, {
                            default: _withCtx(() => [
                              _hoisted_27
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    index: "3",
                    disabled: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_28
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "4" }, {
                    default: _withCtx(() => [
                      _hoisted_29
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["default-active", "onSelect"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}